import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { ErroredRow } from 'dashboard/models/importer-run';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

interface ErrorDetailsModalProps {
  errorRow: ErroredRow | null;
  hideErrorModal: () => void;
}

const ErrorMessageText = styled(Paragraph)`
  background-color: ${({ theme }) => theme.color.background.disabled};
  border-radius: ${({ theme }) => theme.element.borderRadius};
  color: ${({ theme }) => theme.color.text.primary};
  font-family: 'Courier';
  min-height: 120px;
  padding: ${Spacing[3]};
`;

const ErrorDescription = styled(Paragraph)`
  color: ${({ theme }) => theme.color.text.primary};
`;

const ErrorDetailsModal = ({ errorRow, hideErrorModal }: ErrorDetailsModalProps) => {
  if (!errorRow) {
    return null;
  }
  return (
    <ModalContainer>
      <ModalHeader data-test='error-details-modal__modal' onClose={hideErrorModal}>
        Error Details
      </ModalHeader>
      <ModalBody>
        <ErrorDescription>
          {`There was an error running your import for Row ${errorRow['row-number']}. Please view the error message below to troubleshoot`}
        </ErrorDescription>
        <Spacer height={2} />
        <ErrorMessageText>{errorRow['error-message']}</ErrorMessageText>
      </ModalBody>
    </ModalContainer>
  );
};

export default ErrorDetailsModal;
